function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgAuditCheckedFilledIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.21 15.33A3.25 3.25 0 1 0 12.25 9h-.016a3.216 3.216 0 0 0-.234.01A3.253 3.253 0 0 0 9.087 13a3.256 3.256 0 0 0 2.123 2.33Zm2.844-3.476a.5.5 0 0 0-.708-.708L11.7 12.793l-.846-.847a.5.5 0 0 0-.708.708l1.2 1.2a.5.5 0 0 0 .708 0l2-2Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88 15.778A4.252 4.252 0 0 1 8.065 13H3.5a.5.5 0 0 1 0-1h4.507c.02-.346.082-.681.18-1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.5l.186-1.492a2 2 0 1 1 2.627 0L9.5 7H12a1 1 0 0 1 1 1v.066a4.252 4.252 0 0 1 2.778 1.814 8 8 0 1 0-5.898 5.898Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.656 4.754-.4.35L8.616 8H12v.007A4.248 4.248 0 0 0 8.644 10H4V8h3.383l.362-2.896-.401-.35a1 1 0 1 1 1.313 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgAuditCheckedFilledIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgAuditCheckedFilledIcon);
export default Memo;